import getAsset from '~/helpers/getAsset';
import * as entityId from '../../../../../constants/entityIds';

export const addOnData = {
  [entityId.WHOLE_HOME_WIFI]: {
    title: 'Whole-Home Wi-Fi',
    image: {
      alt: 'Whole-Home Wi-Fi',
      src: getAsset('/images/icons/icon-home-wifi.svg'),
      height: '50',
      width: '50',
    },
    description: 'Expand your Wi-Fi reach with up to two Wi-Fi devices.',
    content: {
      subheading: 'What does Whole-Home Wi-Fi do?',
      subcopy:
        'Whole-Home Wi-Fi is an add-on to your internet plan to help you get Wi-Fi coverage in those hard-to-reach places in your home. For just $10/mo. you get up to two eero devices capable of extending your Wi-Fi coverage up to 4,000 sq. ft.',
      checklist: {
        heading: 'How it works:',
        useCheckIcons: false,
        items: [
          {
            text: '1. During your internet installation, one of our technicians will do a professional consultation. They’ll decide the best number and location of your additional Wi-Fi devices.',
          },
          {
            text: '2. They’ll install the devices for you during your appointment window.',
          },
          {
            text: '3. You’re all set! Enjoy extended Wi-Fi coverage in your home.',
          },
        ],
      },
    },
  },
  [entityId.UNBREAKABLE_WIFI]: {
    title: 'Unbreakable<sup>&trade;</sup> Wi-Fi',
    image: {
      alt: 'Unbreakable Wi-Fi',
      src: getAsset('/images/icons/icon-wifi-lock.svg'),
      height: '50',
      width: '50',
    },
    content: {
      subheading: 'Stay connected with backup internet that automatically turns on if your connection goes down.',
      checklist: {
        useCheckIcons: true,
        items: [
          {
            headingInline: 'Simple, one-time setup.',
          },
          {
            headingInline: 'Automatically switches your Wi-Fi if the internet goes out so your devices stay connected.',
          },
          {
            headingInline: 'Stay online with a backup connection during network outages.',
          },
        ],
      },
    },
  },
  [entityId.WIFI_SECURITY]: {
    title: 'Wi-Fi Security',
    content: {
      subheading:
        "If it's connected, you're protected. Wi-Fi Security helps defend your home network from online threats.",
      contentImage: {
        alt: 'Wi-Fi Security',
        src: getAsset('/images/product-selection/eero-secure.png'),
        width: '200',
        className: 'eero-secure-phone',
      },
      checklist: {
        useCheckIcons: true,
        items: [
          {
            headingInline: 'Wi-Fi controls and ad-free browsing',
          },
          {
            headingInline: 'Advanced parental tools such as time limits and website blocking',
          },
          {
            headingInline: 'Device security to prevent accidental visits to malicious sites',
          },
        ],
      },
    },
  },
  [entityId.YTTV_BASIC]: {
    image: {
      alt: 'YouTube TV',
      src: getAsset('/images/logos/yttv-logo.svg'),
      width: '200',
    },
    description: 'Watch 100+ channels of live sports, news, shows and movies.',
    content: {
      subheading: 'What’s included?',
      subcopy:
        'YouTube TV is a live TV streaming service with 100+ channels, unlimited DVR space included, and 6 household accounts! Add YouTube TV to your Frontier account and save $10/mo. on your first year.',
      subcopyLegal: 'youtubeTv',
      checklist: {
        useCheckIcons: true,
        items: [
          {
            text: 'Cancel anytime',
          },
          {
            text: 'Unlimited DVR space included',
          },
          {
            text: '6 accounts per household with 3 simultaneous stream',
          },
          {
            text: 'No cable box needed',
          },
        ],
      },
      channels: {
        heading: 'Get access to some of the most popular channels, plus many more',
        image: {
          alt: 'Group of supported channels',
          src: getAsset('/images/channels/channels-group.png'),
          width: '350',
          mobileWidth: '250',
        },
        link: {
          text: 'View full channel list',
          href: 'https://tv.youtube.com/welcome/',
        },
      },
      setupInfo: {
        heading: 'Setup information',
        items: [
          'After you submit your internet order, you’ll get both a text message and an email containing a personalized YouTube TV activation link. You can use either one to get set up.',
          "When you click the link, you’ll be asked to sign in to your Google account. If you don’t have a Google account, you’ll need to create one. Note: If you have a Google account and previously used it for a free trial or subscription to YouTube TV, you can't use it to activate your discounted service through Frontier. You’ll need to create a new account.",
          'Sign in to your account. You’ll be asked for permission to allow us to start, add or remove paid subscriptions to your YouTube account. Select Allow.',
          'You’ll be taken to a page with an overview of your special savings and monthly payment. Select Activate Now to activate your subscription. You’re all set!',
        ],
      },
    },
  },
  [entityId.UNLIMITED_VOICE]: {
    title: 'Unlimited Digital Voice',
    image: {
      alt: 'Unlimited Digital Voice',
      src: getAsset('/images/icons/icon-phone-red.svg'),
      height: '50',
      width: '50',
    },
    description: 'Get peace of mind with a reliable home phone line.',
    content: {
      checklist: {
        heading: 'Features:',
        useCheckIcons: true,
        items: [
          {
            text: 'Call management functions such as caller ID, Call Waiting and Voicemail',
          },
          {
            text: 'Unlimited nationwide and long-distance calling',
          },
          {
            text: 'Clear call quality',
          },
        ],
      },
    },
    subDescription:
      'Whether you’re calling into work meetings from the comfort of your home or you’re trying to save minutes on your cell phone plan, adding a home phone can help bring you and your family peace of mind.',
  },
  [entityId.TOTAL_SHIELD]: {
    title: 'Total Shield',
    image: {
      alt: 'Total Shield',
      src: getAsset('/images/icons/icon-shield-red.svg'),
      height: '50',
      width: '50',
    },
    description:
      'Three-in-one software subscription to protect your connected devices and identity at home or on public Wi-Fi. Includes Multi-Device Security, Password Manager, and VPN privacy for safe browsing.',
    content: {
      checklist: {
        useCheckIcons: false,
        items: [
          {
            heading: 'Multi-Device Security',
            text: 'Protect up to 10 PC, Mac, Android and iOS devices from malware and viruses. Set family rules to help safeguard children while they use the internet',
          },
          {
            heading: 'Password Manager',
            text: 'Use one master password to safely store and auto-fill your login credentials.',
          },
          {
            heading: 'VPN',
            text: 'A VPN helps enhance the overall security of your connection. It masks your IP address and encrypts your communication.',
          },
        ],
      },
    },
  },
  [entityId.IDENTITY_PROTECTION]: {
    title: 'Identity Protection',
    image: {
      alt: 'Identity Protection',
      src: getAsset('/images/icons/icon-shield-identity-red.svg'),
      height: '32',
      width: '44',
    },
    description:
      'This service provides triple-bureau credit monitoring, alerts you to credit changes and assists in identity restoration with up to $1M identity theft insurance.',
    content: {
      checklist: {
        heading: 'Features:',
        useCheckIcons: true,
        items: [
          {
            text: 'Triple-bureau credit monitoring quickly alerts you to changes in your credit report',
          },
          {
            text: 'Monitors Social Security Number, driver’s license, passports, medical IDs, debit/credit cards, and more',
          },
          {
            text: 'Lost wallet services and certified support specialists to help cancel and reissue lost or stolen information',
          },
          {
            text: 'Identity restoration services, and up to $1,000,000 identity theft insurance coverage',
          },
        ],
      },
    },
  },
  [entityId.MY_PREMIUM_TECH_PRO]: {
    title: 'My Premium Tech Pro',
    image: {
      alt: 'My Premium Tech Pro',
      src: getAsset('/images/icons/icon-headset.svg'),
      height: '50',
      width: '50',
    },
    description:
      'Get a dedicated phone number to connect with live tech experts. Our experts can help you set up and troubleshoot services, device(s), apps and software, and answer any other technical questions you may have along the way.',
    content: {
      checklist: {
        heading: 'Details',
        useCheckIcons: false,
        items: [
          {
            heading: 'Reach an expert easily',
            text: 'Call a dedicated phone number to speak with a specialist 7 a.m. to midnight ET, 365 days a year.',
          },
          {
            heading: 'Ask any tech question',
            text: 'Get help with nearly any tech questions about your device(s), internet, home network, and more.',
          },
          {
            heading: 'Get answers in one call',
            text: 'Our certified tech specialists can typically resolve issues in one call.',
          },
        ],
      },
    },
  },
  [entityId.WIFI_SECURITY_PLUS]: {
    title: 'Wi-Fi Security Plus',
    content: {
      subheading:
        'Get all the features from Wi-Fi Security, plus a suite of premium software to help protect yourself from online attacks.',
      checklist: {
        useCheckIcons: false,
        items: [
          {
            heading: 'Malwarebytes anti-virus software:',
            text: 'Award-winning antivirus software that helps protect your devices from malware, hackers and other online threats.',
          },
          {
            heading: '1Password password manager:',
            text: 'Store your passwords, account credentials and other sensitive information in a secure system.',
          },
          {
            heading: 'Guardian VPN Protection:',
            text: 'A VPN masks your IP address and encrypts your data when you use the internet, making your experience safer and more private.',
            tooltip: 'VPN powered by Guardian works only with devices running macOS, iOS, or Android.',
          },
        ],
      },
    },
  },
  [entityId.NETFLIX_BUNDLE]: {
    title: 'Netflix & Pro Wi-Fi Bundle',
    image: {
      alt: 'Netflix & Pro Wi-Fi Bundle',
      src: getAsset('/images/icons/icon-netflix.svg'),
      height: '50',
      width: '50',
    },

    content: {
      checklist: {
        heading: 'Get powerful and secure Wi-Fi throughout your home, plus Netflix Premium.',
        useCenteredHeading: true,
        useBoldHeading: true,
        useCheckIcons: true,
        items: [
          {
            bold: 'Pro Wi-Fi',
            text: 'Experience powerful and secure Wi-Fi throughout your home with Whole-Home Wi-Fi and Wi-Fi Security.',
          },
          {
            bold: 'Netflix Premium',
            text: 'Movies, series, and games for the whole family. Watch ad-free in Ultra HD 4K on up to 4 devices and download on 6 devices.',
          },
          {
            bold: 'All-in-one savings',
            text: 'Bundle our top two Wi-Fi services and Netflix Premium in one bill. Save $95 annually.',
          },
        ],
      },
    },
  },
};
